import React, { useState } from 'react'
import { Modal } from 'almanac-ui/Modal'
import { StackModalProps } from 'almanac-ui/Modal/Types'
import { Text } from 'blaze-ui/Text/Text'
import ToggleButton from 'common/ToggleButton/ToggleButton'
import { useUpsertAutoReplyConfig } from 'hooks/queries/autoReplyConfig/useUpsertAutoReplyConfig'
import Styles from 'components/SelectConnectableAccountsModal/SelectConnectableAccountsModal.module.scss'

interface AutoReplyConfigScreenProps {
  autoReplyEnabled: boolean
  setAutoReplyEnabled: (enabled: boolean) => void
}

export const AutoReplyConfigScreen = ({ autoReplyEnabled, setAutoReplyEnabled }: AutoReplyConfigScreenProps) => {
  return (
    <div className={Styles.autoReplyScreen}>
      <div className={Styles.autoReplyIcon}>💬</div>
      <Text variant="largeList">Would you like Blaze to automatically engage with your audience?</Text>
      <div className={Styles.autoReplyToggleRow}>
        <div className={Styles.autoReplyToggleInfo}>
          <Text variant="largeList" fontWeight="bold">
            Auto-replies for comments
          </Text>
          <Text variant="placeholder">
            Blaze will automatically reply to comments on your posts to keep conversations going.
          </Text>
        </div>
        <ToggleButton
          checked={autoReplyEnabled}
          name="auto-reply-toggle"
          handleChange={() => setAutoReplyEnabled(!autoReplyEnabled)}
        />
      </div>
      <Text variant="placeholder" color="var(--neutral-40)">
        You can change these settings anytime from the Integrations page.
      </Text>
    </div>
  )
}

interface AutoReplySetupModalProps extends StackModalProps {
  integrationId?: number
  integrationIds?: number[]
  onClose?: () => void
}

export const AutoReplySetupModal = ({ integrationId, integrationIds, close, onClose }: AutoReplySetupModalProps) => {
  const [autoReplyEnabled, setAutoReplyEnabled] = useState(true)
  const { mutate: upsertAutoReplyConfig } = useUpsertAutoReplyConfig()
  const ids = integrationIds ?? (integrationId ? [integrationId] : [])

  const handleClose = () => {
    close()
    onClose?.()
  }

  const handleFinish = () => {
    if (autoReplyEnabled && ids.length > 0) {
      upsertAutoReplyConfig({
        enabled: true,
        enabled_external_integration_ids: ids,
      })
    }
    handleClose()
  }

  return (
    <Modal.Root size="sm">
      <Modal.Header title="Almost done! 🎉" />
      <Modal.Content>
        <AutoReplyConfigScreen autoReplyEnabled={autoReplyEnabled} setAutoReplyEnabled={setAutoReplyEnabled} />
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton size="lg" variant="tertiary" onPress={handleClose}>
            Skip for now
          </Modal.FooterButton>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Modal.FooterButton size="lg" onPress={handleFinish}>
            Finish Setup
          </Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
